import { createLazyFileRoute } from "@tanstack/react-router";

import { BrowsePage } from "@/features/browse/routes/Browse";

export const Route = createLazyFileRoute("/_auth/_app/browse/")({
  component: BrowsePage,
});
